// 1. The Master Manifest: The ONLY place you ever edit if sizes or Drupal names change
export const IMAGE_QUALITY_PROFILES = [
    { id: 'xxs', width: 150, drupalMachineName: 'je' },
    { id: 'xs', width: 300, drupalMachineName: 'jd' },
    { id: 's', width: 600, drupalMachineName: 'jc' },
    { id: 'm', width: 1200, drupalMachineName: 'jb' },
    { id: 'l', width: 2400, drupalMachineName: 'ja' },
    { id: 'xl', width: 5000, drupalMachineName: 'jo' },
] as const;

// 2. Derive the strict literal string types automatically for Panel.tsx & Animation.tsx
export type ImageSize = (typeof IMAGE_QUALITY_PROFILES)[number]['id'];

// 3. Keep your original legacy array export intact so Panel.tsx doesn't break
export const IMAGE_SIZES = IMAGE_QUALITY_PROFILES.map(
    (profile) => profile.id,
) as unknown as readonly ImageSize[];

// 4. Derive the width mapping for Animation.tsx selectableSizes
export const SELECTABLE_IMAGE_SIZES = IMAGE_QUALITY_PROFILES.map((profile) => ({
    id: profile.id,
    width: profile.width,
}));

// 5. Derive the exact usageDefaultSizeMap required by Photo.tsx & AnimationUtilities.ts
export const USAGE_DEFAULT_SIZE_MAP: Record<ImageSize, string> =
    IMAGE_QUALITY_PROFILES.reduce(
        (acc, profile) => {
            acc[profile.id] = profile.drupalMachineName;
            return acc;
        },
        {} as Record<ImageSize, string>,
    );
